import { css } from '@emotion/react';

export const containerStyle = css`
  position: relative;
`;

export const buttonStyle = css`
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
`;
